import api from "lib/axios";
import { ApiEnvelope, unwrapData } from "./apiTypes";

export type StudentCourseEnrollment = {
  course_id: number;
  title: string;
  subject_name?: string | null;
  instructor_name?: string | null;
  price?: number | null;
  currency?: string | null;
  pricing_type?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  enrolled_by?: number | null;
  payment_status?: string | null;
  source_type?: string | null;
  source_id?: number | null;
};

export type StudentCourseOption = {
  id: number;
  title: string;
  subject?: { id: number; name: string } | null;
  price?: number | null;
  currency?: string | null;
  pricing_type?: string | null;
};

export type StudentCoursePayload = {
  start_date?: string | null;
  end_date?: string | null;
  payment_status?: string | null;
};

export const adminStudentCoursesService = {
  async list(studentId: number | string) {
    const response = await api.get<ApiEnvelope<{ data: StudentCourseEnrollment[] }>>(
      `/mcp/students/${studentId}/courses`,
      { meta: { toastSuccess: false } }
    );
    return unwrapData<StudentCourseEnrollment[]>(response.data) ?? [];
  },

  async options(studentId: number | string) {
    const response = await api.get<ApiEnvelope<{ data: StudentCourseOption[] }>>(
      `/mcp/students/${studentId}/course-options`,
      { meta: { toastSuccess: false } }
    );
    return unwrapData<StudentCourseOption[]>(response.data) ?? [];
  },

  async attach(studentId: number | string, courseId: number, payload: StudentCoursePayload) {
    const response = await api.post<ApiEnvelope<{ data: StudentCourseEnrollment }>>(
      `/mcp/students/${studentId}/courses`,
      { course_id: courseId, ...payload }
    );
    return unwrapData<StudentCourseEnrollment>(response.data);
  },

  async update(studentId: number | string, courseId: number, payload: StudentCoursePayload) {
    const response = await api.put<ApiEnvelope<{ data: StudentCourseEnrollment }>>(
      `/mcp/students/${studentId}/courses/${courseId}`,
      payload
    );
    return unwrapData<StudentCourseEnrollment>(response.data);
  },

  async remove(studentId: number | string, courseId: number) {
    const response = await api.delete(`/mcp/students/${studentId}/courses/${courseId}`);
    return response.data;
  },
};
